import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

const STUB_RESPONSE =
    'I would normally reach out to the GeoPlay agent for this. This is a stub response — ' +
    'wire this component up to your real AI endpoint to stream a live answer.';

export const CommandPaletteAI = ({ query }) => {
    const [shown, setShown] = useState('');
    const [done, setDone] = useState(false);

    useEffect(() => {
        setShown('');
        setDone(false);
        let i = 0;
        const interval = setInterval(() => {
            i += 2;
            if (i >= STUB_RESPONSE.length) {
                setShown(STUB_RESPONSE);
                setDone(true);
                clearInterval(interval);
                return;
            }
            setShown(STUB_RESPONSE.slice(0, i));
        }, 15);
        return () => clearInterval(interval);
    }, [query]);

    return (
        <div className="cp-ai">
            <div className="cp-ai-query">
                <FontAwesomeIcon icon={faWandMagicSparkles} className="cp-ai-icon" />
                <span>{query}</span>
            </div>
            <div className="cp-ai-response">
                {shown}
                {!done && <span className="cp-ai-cursor" />}
            </div>
        </div>
    );
};
